export default __webpack_public_path__ + "static/media/map_icon_blue_light.74a4b10a.svg";